import FacilityImage from './FacilityImage';

export default FacilityImage;
